import React from 'react';
import { Link } from 'react-router-dom';
import { newsStories } from '../data/news';
type Story = (typeof newsStories)[number];
export function News() {
  const [lead, ...rest] = newsStories;
  return <section id="news" aria-labelledby="news-heading" className="bg-paper px-6 py-14 md:px-16 md:py-24" data-id="element-913" data-mp="3gires2dl34ru">
      <div className="mx-auto max-w-[1320px]" data-id="element-914" data-mp="3li3wy9tifno3">
        <div className="flex items-end justify-between gap-6 border-b border-ink pb-5" data-id="element-915" data-mp="3livuvrakxxhj">
          <h2 id="news-heading" className="text-[26px] font-normal leading-[34px] tracking-[-0.01em] md:text-[34px] md:leading-[42px]" data-id="element-916" data-mp="d3c5j3d14z7r">
            Lately, behind closed doors
          </h2>
        </div>

        {/* Lead story — headline first, image in support */}
        <article className="border-b border-line py-6 md:py-8 lg:py-10" data-id="element-917" data-mp="897y6izuqp65">
          <Link to={lead.href} className="group grid grid-cols-1 gap-4 md:gap-6 lg:grid-cols-12 lg:items-end lg:gap-10" data-id="element-918" data-mp="vzlfbegwf3ly">
            <div className="aspect-[16/9] overflow-hidden bg-mist lg:col-span-8" data-id="element-919" data-mp="10rvapa0s8vvm">
              <img src={lead.image} alt={lead.alt} className="h-full w-full object-cover transition-transform duration-[1200ms] ease-luxe group-hover:scale-[1.04]" data-id="element-920" data-mp="2xqzd6dikzdf5" />
            </div>
            <div className="lg:col-span-4 lg:pb-1" data-id="element-921" data-mp="37iws9vcpmpj5">
              <Meta story={lead} data-id="element-922" data-mp="32qlo2gaxshks" />
              <h3 className="mt-2 max-w-[420px] font-editorial text-[24px] font-normal leading-[28px] tracking-[-0.01em] transition-opacity duration-300 group-hover:opacity-70 md:mt-4 md:text-[34px] md:leading-[38px] lg:text-[38px] lg:leading-[42px]" data-id="element-923" data-mp="32paj4d5r93s3">
                {lead.title}
              </h3>
              <span className="mt-6 hidden items-center gap-3 text-[15px] font-medium md:inline-flex" data-id="element-924" data-mp="3qfogmj73zuu2">
                Read the announcement
                <span aria-hidden="true" className="transition-transform duration-500 ease-luxe group-hover:translate-x-1" data-id="element-925" data-mp="1w25ban6u77y7">
                  →
                </span>
              </span>
            </div>
          </Link>
        </article>

        {/* Three equal stories — compact thumbnail rows on mobile, image-first columns from tablet up */}
        <ul className="grid grid-cols-1 md:grid-cols-3" data-id="element-926" data-mp="2ktukml4333ap">
          {rest.map((story, i) => <li key={story.title} className={`border-b border-line md:border-b-0 ${i > 0 ? 'md:border-l md:border-line' : ''}`} data-id="element-927" data-mp="2pre90duhwwgd" data-mpi={i}>
              <Link to={story.href} className={`group flex h-full items-center gap-4 py-4 md:flex-col md:items-stretch md:gap-0 md:py-10 ${i === 0 ? 'md:pr-8' : i === rest.length - 1 ? 'md:pl-8' : 'md:px-8'}`} data-id="element-928" data-mp="2zqv7obbbya2u">
                <div className="aspect-square w-[96px] shrink-0 overflow-hidden bg-mist md:aspect-[16/10] md:w-auto" data-id="element-929" data-mp="38kqdzmo6u6k2">
                  <img src={story.image} alt={story.alt} className="h-full w-full object-cover transition-transform duration-[1200ms] ease-luxe group-hover:scale-[1.05]" data-id="element-930" data-mp="3igteko3e5x4w" />
                </div>
                <div className="min-w-0" data-id="element-931" data-mp="1bqhru331jdwp">
                  <div className="md:mt-5" data-id="element-932" data-mp="16syd722fkz48">
                    <Meta story={story} data-id="element-933" data-mp="16s6hzscqx3eh" />
                  </div>
                  <h3 className="mt-1 font-editorial text-[19px] font-normal leading-[23px] tracking-[-0.005em] transition-opacity duration-300 group-hover:opacity-70 md:mt-3 md:text-[26px] md:leading-[31px] xl:text-[28px] xl:leading-[33px]" data-id="element-934" data-mp="11tlixw98cprm">
                    {story.title}
                  </h3>
                </div>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}
function Meta({
  story
}: {
  story: Story;
}) {
  return <p className="text-[13px] font-light text-ink/70 md:text-[15px]" data-id="element-935" data-mp="1fu5zelroa9hy">
      <span className="font-medium text-ink" data-id="element-936" data-mp="1ftwbr4u3oeff">{story.category}</span>
      <span className="mx-2" aria-hidden="true" data-id="element-937" data-mp="2dalh38i9dytk">·</span>
      {story.date}
    </p>;
}